import {
  GET_LOCATION_FAIL,
  GET_LOCATION_SUCCESS,
  GET_LOCATIONS_FAIL,
  GET_LOCATIONS_SUCCESS,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_FAIL,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_FAIL,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_FAIL,  
  SET_STATE_LOCATION
} from "./actionTypes";

const INIT_STATE = {
  locations: [],
  location: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const location = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: action.payload.locations,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LOCATION:
      return { ...state, loading: action.payload }

    case GET_LOCATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LOCATION_SUCCESS:
      return {
        ...state,
        locations: [...state.locations, action.payload],
      };

    case ADD_LOCATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LOCATION_SUCCESS:
      return {
        ...state,
        locations: state.locations.map(location =>
          location.id.toString() === action.payload.id.toString()
            ? { ...action.payload, location }
            : location
        ),
      };

    case UPDATE_LOCATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LOCATION_SUCCESS:
      return {
        ...state,
        locations: state.locations.filter(
          location => location.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LOCATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LOCATION_SUCCESS:
      return {
        ...state,
        location: action.payload,
      };

    case GET_LOCATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default location;
